import { when } from 'mobx';
import { inject, observer } from 'mobx-react';

import * as React from 'react';
import * as ReactModal from 'react-modal';

import { withRouter, RouteComponentProps } from 'react-router';
import { ApplicationStore } from '../../_stores/ApplicationStore';

import { CloseButton } from '../../SharedComponents/CloseButton';
import { SupportDropdown } from '../../SharedComponents/MainPageWithNavigator/AccountSettingsDropdown';

import {
    ModalXIconDark,
    SupportButtonIcon,
    TightKnitLogoWhite
} from '../../images/images';

import { styles } from '../../SharedComponents/MainPageWithNavigator/NavigatorStyles';

import './LearningCenter.css';

interface IProps extends RouteComponentProps<{}> {
    store?: ApplicationStore;
    show: boolean;
    handleClose: any;
    itemId: number;
}

interface IState {
    learningCenterItemId: number;
    learningCenterItems: any;
    learningCenterItem: any;
    showMenu: boolean
}

@inject('store')
@observer
export class LearningCenterComponent extends React.Component<IProps> {

    public state: IState = {
        learningCenterItemId: 0,
        learningCenterItems: [],
        learningCenterItem: {
            title: '',
            intro: '',
            steps: [],
            video_embed: ''
        },
        showMenu: false,
    };

    public componentDidMount(): void {


        when(
            () =>
                this.props.store!.learningCenterStore &&
                this.props.store!.learningCenterStore.items.length > 0,
            async () => {
                this.setState({learningCenterItems: this.props.store!.learningCenterStore.items});
                if (this.props.itemId) {
                    console.log('have item id');
                    this.setState({learningCenterItemId: this.props.itemId});
                    this.setLearningCenterItem(this.props.itemId);
                } else {
                    console.log(this.props.store!.learningCenterStore.items[0]);
                    let firstItemID = this.props.store!.learningCenterStore.items[0].id;
                    this.setState({learningCenterItemId: firstItemID});
                    this.setLearningCenterItem(firstItemID);
                }
                console.log('⭐ Store loaded');

            },
        );

    }

    public componentDidUpdate () {
        console.log('component updated');
    }

    public setLearningCenterItem (itemId: number) {
        console.log('setLearningCenterItem');
        console.log(itemId);
        console.log('this.props', this.props);
        let item = this.props.store!.learningCenterStore.getItemById(itemId);
        this.setState({learningCenterItem: item});

    }

    public render() {
        console.log('this.props.store', this.props.store!.learningCenterStore);
        console.log('this.state', this.state);

        const {title, intro, steps, video_embed} = this.state.learningCenterItem;
        return (
            <ReactModal
                isOpen={this.props.show}
                contentLabel="onRequestClose Example"
                onRequestClose={this.props.handleClose}
                className="learningCenterModal__modal"
                overlayClassName="learningCenterModal__overlay"
            >
                <div className="learningCenterModal__header">
                    <img className="learningCenterModal__header__logo" src={TightKnitLogoWhite} />

                    <h2 className="learningCenterModal__header__title">Learning Center</h2>
                    <div className="learningCenterModal__header__controls">
                        <div className="learningCenterModal__dropdown">
                            <img
                                style={styles.navButtonIcon}
                                src={SupportButtonIcon}
                                onClick={() => this.setState({ showMenu: !this.state.showMenu })}
                            />
                            {this.state.showMenu &&
                                <SupportDropdown
                                    isInLearningCenter={true}
                                    showItem={(id: number) => {
                                        this.setLearningCenterItem(id);
                                        this.setState({showMenu: false});
                                    }}
                                    {...this.props}
                                />
                            }
                        </div>
                        <CloseButton
                            dark={true}
                            onClick={() =>
                                this.props.handleClose()
                            }
                        />
                    </div>

                </div>
                <div className="learningCenterModal__body">

                    <div className="learningCenterModal__sidebar">
                        <h3 className="learningCenterModal__sidebar__title">What You Will Learn</h3>
                        <div dangerouslySetInnerHTML={{ __html: intro }}></div>
                        {this.state.learningCenterItem.steps &&
                        <ol>
                            {steps.map((step: any, stepIndex: number) => (
                                <li key={stepIndex}>{step.step}</li>
                            ))}
                        </ol>
                        }
                        <div className="learningCenterModal__sidebar__help">
                            <div className="learningCenterModal__sidebar__help__item">
                                <img
                                    className="learningCenterModal__sidebar__icon"
                                    src={SupportButtonIcon}
                                />
                                <p>Click any time to launch help and access all of the Learning Center videos.</p>
                            </div>
                            <div className="learningCenterModal__sidebar__help__item">
                                <img
                                    className="learningCenterModal__sidebar__icon"
                                    src={ModalXIconDark}
                                />
                                <p>Click to exit the Learning Center and return to TightKnit.</p>
                            </div>
                        </div>


                    </div>
                    <div className="learningCenterModal__main">

                        <h3 className="learningCenterModal__main__title">{title}</h3>
                        <div className="embed-container" dangerouslySetInnerHTML={{ __html: video_embed }}>

                        </div>
                    </div>
                </div>
                {this.state.showMenu &&
                    <div className="learningCenterModal__menuOverlay"
                         onClick={() => this.setState({showMenu: false})} />
                }
            </ReactModal>
        );
    }
}

export const LearningCenter = withRouter<IProps>(LearningCenterComponent);



// WEBPACK FOOTER //
// ./src/_modals/LearningCenter/LearningCenter.tsx